import { Person } from '../../../interfaces/person';
import { Position } from '../../../enums/position';

function findActiveKeeper(players: Person[], teamId: number): Person | undefined {
  return players.find((person: Person) => {
    if (person.teamId === teamId && person.currentlyOnTheField) {
      return person.position.id === Position.KEEPER || person.positionIdTeam === Position.KEEPER;
    }
  });
}

export default findActiveKeeper;
